// extracted by mini-css-extract-plugin
module.exports = {"svg":"SVG_svg__NWl8B"};